import Stage from "../Stage";
import LoadMovie from "../LoadMovie";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import StudioLayout from "../StudioLayout";
import ErrorOverlay from "../../components/ErrorOverlay";
import { selectShowDebugUi } from "../../store/uiSlice";

export default function DirStudio() {
  // Seeded from the build's own answer, but overridable from the load screen,
  // so this has to be read live rather than captured once at mount.
  const showDebugUi = useSelector<RootState, boolean>((state) => selectShowDebugUi(state.ui));
  const isMovieLoaded = useSelector<RootState, boolean>((state) => !!state.vm.isMovieLoaded);
  const movieLoadError = useSelector<RootState, string | undefined>((state) => state.vm.movieLoadError);

  if (movieLoadError && !showDebugUi) {
    return <div style={{ width: '100vw', height: '100vh' }}>
      <ErrorOverlay message={movieLoadError} />
    </div>;
  }
  if (!isMovieLoaded) {
    return <LoadMovie />;
  }
  if (!showDebugUi) {
    return <div style={{ width: '100vw', height: '100vh' }}>
      <Stage enableGestures />
    </div>
  }
  return <StudioLayout />;
}
